import { toUrl } from "@/utils/textUtilities";
import { isFalse, isTrue } from "@/utils/service/DocumentGeneration/answers";
import inputRules from "@/utils/inputRules";

export function transform(data) {
    const params = {
        ...data
    };
    const include = [];

    if (isTrue(data.privacyPolicy.use)) {
        include.push("privacy_policy");
        params["privacy_policy_link"] = toUrl(data.privacyPolicy.link);
    } else if (
        isFalse(data.privacyPolicy.use) &&
        data.privacyPolicy.no_use_create
    ) {
        if (inputRules.url(data.privacyPolicy.no_use_create) === true) {
            include.push("privacy_policy");
            params["privacy_policy_link"] = toUrl(
                data.privacyPolicy.no_use_create
            );
        }
    }

    return {
        include,
        ...params,
    };
}

export function retransform(params) {
    const privacyPolicy = {
        use: params.include.includes("privacy_policy"),
        link: params.privacy_policy_link,
    };

    return {
        ...params,
        privacyPolicy,
    };
}
